module.exports = __webpack_public_path__ + "img/logo.4f194190.png";